import httpClient from '../utils/httpClient';

export const GetSessionTimeOut = async () => {
    const response = await httpClient.get('/AutoLogout/sessionTimeOut');
    return response.data;
};

export const UserLogout = async () => {
    const response = await httpClient.post('/User/logout');
    return response.data;
};

